import { useEffect, useState } from "react";
import { getFriendRequests, acceptRequest, getFriendsList } from '../../Services/Inbox.js';
import { getInfoByUsrId } from '../../Services/User.js';
import ProfilePic from '../../assets/iconos/perf360.svg'
import { te } from "date-fns/locale";


const ContactList = (props) => {

    const [solicitudesPendientes, setSolicitudesPendientes] = useState(null);
    const [firendList, setFriendList] = useState(null);


    const loadRequests = async () => {
        let rsp = await getFriendRequests();

        if(rsp.Error == false && rsp.Data.length > 0){
            setSolicitudesPendientes(rsp.Data);
        }

    }

    const acceptRequestUser = async (id) => {
        await acceptRequest(id);

        window.location.replace('?view=buzon');
    }

    const loadFriendList = async () => {
        let rsp = await getFriendsList();

        if(rsp.Error == false){
            setFriendList(rsp.Data);
        }
    }

    useEffect(() => {
        loadRequests();
        loadFriendList();
    }, []);


    return(
        <>
            {
                solicitudesPendientes != null ?
                <>
                <div className="contacts-title-container">
                    <div className='new-contact'>
                        <h5>Solicitudes</h5>
                    </div>
                </div>
                {
                        solicitudesPendientes.map((item) => {
                            return(
                                <div  className='chat-card setpointer' key={item.id + 'sl'}> 
                                <div className='chat-picture'>
                                    <img src={item.url_profile_pic || ProfilePic } alt="contact-picture" className='chat-pic'/>
                                </div>
                                <div className='contact-info'>
                                    <div className='contact-name'>
                                        <h4>{item.name}</h4>
                                    </div>
                                    <div className='last-message'>
                                        <p>Pendiente</p>
                                    </div>
                                </div>
                                <button className="green-btn sethoverdark setpointer" onClick={() => acceptRequestUser(item.id)}>Aceptar Solicitud</button>
                            </div>
                        );
                    })
                }
                </>
                :
                <></>
            }
            {
                firendList != null ?
                <>
                <div className="contacts-title-container">
                    <div className='new-contact'>
                        <h3>Contactos</h3>
                    </div>
                </div>
                {
                    firendList.map((item) => {
                        return(
                            
                            <div  className='chat-card setpointer' key={item.id + 'fr'}> 
                                <div className='chat-picture'>
                                    <img src={item.url_profile_pic || ProfilePic } alt="contact-picture" className='chat-pic'/>
                                </div>
                                <div className='contact-info'>
                                        <h4>{item.name}</h4>
                                        <p>Contacto</p>
                                </div>
                                <button className="green-btn sethoverdark setpointer" onClick={() => props.setContact({send: true, ...item})}>Enviar Mensaje</button>
                        </div>
                        );
                    })
                }
                </>
                :
                <></>
            }
        </>
    );
}


export default ContactList;